<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">PM2.5记录查询</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 60rem"
              unlink-panels
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="dataTime" label="时间"></el-table-column>
              <el-table-column
                prop="deviceName"
                label="监测点"
              ></el-table-column>
              <el-table-column prop="value" label="PM2.5">
                <template slot-scope="scope">
                  {{ gettem(scope.row.value) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { enviromentData } from "../../../../../request/api";
export default {
  name: "PM25RecordList",
  controller: "UI",
  action: "PM25RecordList",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      PlateNo: "",
      date: [new Date(), new Date()],
      bigImg: "",
      isShowPop: false,
    };
  },
  created: function () {},
  mounted: function () {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        dataStartTime: this.date[0],
        dataEndTime: this.date[1],
        type: "biz_env_pm25",
      };
      enviromentData(params).then((res) => {
        console.log("pm2.5记录");
        console.log(res);
        that.total = res.count;
        that.tableData = res.data;
      });
    },
    gettem(val) {
      return val.toFixed(2) + "μg/cm³";
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.getData();
    },
    clearsearch() {
      this.date = [new Date(), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.smallImg {
  width: 30px;
  height: 30px;
}
.bigimg {
  width: 95%;
  height: 95%;
}
</style>